import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "bookList" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "imgContent" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "tools" }
const _hoisted_8 = {
  key: 1,
  class: "chatContent"
}
const _hoisted_9 = {
  key: 0,
  class: "chat"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "createLoading"
}
const _hoisted_12 = { class: "chatTools" }
const _hoisted_13 = {
  key: 1,
  class: "cateInfo"
}
const _hoisted_14 = { class: "catList" }
const _hoisted_15 = { class: "cateItem" }
const _hoisted_16 = { class: "info" }
const _hoisted_17 = { class: "head" }
const _hoisted_18 = { class: "desc" }
const _hoisted_19 = { class: "children" }
const _hoisted_20 = { class: "cateItem" }
const _hoisted_21 = { class: "info" }
const _hoisted_22 = { class: "head" }
const _hoisted_23 = { class: "desc" }
const _hoisted_24 = { class: "children" }
const _hoisted_25 = { class: "cateItem" }
const _hoisted_26 = { class: "info" }
const _hoisted_27 = { class: "head" }
const _hoisted_28 = { class: "desc" }
const _hoisted_29 = { class: "cateAction" }
const _hoisted_30 = { class: "createImgStep" }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = {
  key: 0,
  class: "seggestStyles"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "seggestColors" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "createImgStep" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { class: "createImgStep" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = ["src"]
const _hoisted_44 = { class: "twoChat" }
const _hoisted_45 = { class: "user" }
const _hoisted_46 = { class: "text" }

import { ref, reactive, onMounted, nextTick } from 'vue';
import { ElMessage, ElButton, ElDialog, ElForm, ElFormItem, ElInput, ElSelect, ElRadioGroup, ElRadio, ElOption, ElIcon, ElMessageBox } from 'element-plus';
import { Delete, get, post, put } from '@/plugins/request'
import router from '@/router/index';
import Session from '@/plugins/session';
import json1 from '@/plugins/json1';
import demo1 from '@/plugins/demo1';
import cateDemo from '@/plugins/cateDemo';

type IBook = {
  id: number;
  name: string;
  desc: string;
  problem: string;
  status: number,
  createUserSystem: string;
  img: string;
  type: number;
}
type CateItem = {
  title: string,
  children?: CateItem[],
  desc: string,
  length: number,
  contentId?: number[],
}
type ICateType = 1 | 2;// 1树状结构，常用于知识。2线性结构，故事/编年体

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const insertVisible = ref<boolean>(false)
const insertStrategy = ref<string>('');
const form = reactive<{
  system: string,
  bookProblem: string,
  outUrl: string,// 外部资料
  cateType: ICateType,
  type: null | number,
}>({
  system: '精通儿童辅食制作',// 你是一个精通html、css和jsPDF三方包使用的专家
  bookProblem: '制作营养丰富的儿童辅食',// jsPDF包如何使用
  outUrl: '',
  cateType: 1,// 1树状结构，常用于知识。2线性结构，故事/编年体
  type: null,
})
const createStep = ref<0 | 1 | 2>(0);
const createCateAnswerLoading = ref<boolean>(false)
const createCateQuestion = ref<string>('')
const createCateAnswerList = ref<Array<{
  text: string,
  role: 'assistant' | 'user'
}>>([])
const createCateJSONLoading = ref<boolean>(false)
const createCateJSON = ref<CateItem[]>([])
const creteLoading = ref<boolean>(false);
// const createBookIng = ref<boolean>(false)
const createChatDom = ref()

const allStyle: {
  [key: string]: string,
} = {
  'Base': '通用风格',
  "3D Model": '3D模型',
  // 'Anime': '动漫', // 动漫分割的封皮，全是日本动漫那种东西
  'Origami': '折纸',
  'Line Art': '线条艺术',
  'Neonpunk': '霓虹朋克',
  'Lowpoly': '低多边形'
}

// 创建封皮
const editImgIsShow = ref<boolean>(false)
const createImgInput = ref<string>('')
const createImgBook = ref<IBook>()
const createImgStep1Answer = ref<string>('')
const createImgUrl = ref<string>()
const createImging = ref<boolean>(false)
const saveImg = ref<boolean>(false)
const createImgStep1StyleSelect = ref<keyof typeof allStyle>();// 第一步待选择的主题
const createImgStep1Colors = ref<string[]>();// 第一步待选择的颜色列表
const createImgStep1ColorsSelect = ref<string>();// 第一步待选择的颜色列表
const createImgStep1ObjectSelect = ref<string[]>();// 第一步待选择的颜色列表
const createImgStep2Answer = ref<string>('')
const createImgStep2AnswerJSON = ref<{
  prompt: string,
}>()
const typeList = ref<Array<{
  id: number,
  name: string,
}>>([])
const bookCount = ref<number>(-1)
const bookList = ref<IBook[]>([])
const bookListLoading = ref<boolean>(false)

// 对抗网络
const twoChatShow = ref<boolean>(false)
const twoChatContnt = ref<{
  user: 'chat1' | 'chat2',
  content: string,
}[]>([])

onMounted(() => {
  const match = location.hash.match(/#token=([^&]*)/);
  if (match) {
    const token = match[1]
    localStorage.setItem('token', token)
    const initText = location.hash.match(/&initText=([^&]*)/);
    if (initText) {
      nextTick(() => {
        initInsert()
        form.bookProblem = decodeURIComponent(initText[1])
      })
    }
    location.hash = '';
  }
  initBookList()
})
async function initBookList() {
  const typeListRes = await get('/bookType');
  console.log('typeListRes', typeListRes)
  typeList.value = typeListRes.map((v: any) => {
    return {
      id: v.id,
      name: v.name,
    }
  })

  const { data, count } = await get(`/bookList`)
  bookCount.value = count;
  bookList.value = data.map((v: any) => {
    return {
      id: v.id,
      name: v.name,
      desc: v.desc,
      problem: v.problem,
      status: v.status,
      createUserSystem: v.createUserSystem,
      img: v.img,
      type: v.type,
    }
  });
  bookListLoading.value = false;
}

function turnDetail(id: number) {
  router.push('/book/editor/' + id)
}
let session: Session;
let sessionImg: Session;
function initInsert() {
  insertVisible.value = true
  form.bookProblem = ''
  form.system = ''
}
async function begin() {
  console.log(form)
  createStep.value = 1;
  createCateAnswerList.value = []
  createCateAnswerLoading.value = true
  session = new Session(form.system)
  const cateDescMap: {
    [key in ICateType]: string
  } = {
    [1]: `你要考虑这本书都需要讲解什么内容。简短告诉我`,
    [2]: cateDemo,
  }
  createCateAnswerList.value.push({
    text: '',
    role: 'assistant'
  });
  // 你可以参考这个网址中[${form.outUrl}]中外部资料作为常识。
  createCateAnswerList.value[createCateAnswerList.value.length - 1].text = await session.chat(`我们一起合作要写一本名讲述${form.bookProblem}的书。${cateDescMap[form.cateType]}`, (res) => {
    createCateAnswerList.value[createCateAnswerList.value.length - 1].text += res;
    if (createChatDom.value) {
      createChatDom.value.scrollTop += 3000
    }
  })
  createCateAnswerLoading.value = false
}
async function chatBeter() {
  createCateAnswerList.value.push({
    text: createCateQuestion.value,
    role: 'user'
  });
  createCateAnswerLoading.value = true
  createCateAnswerList.value.push({
    text: '',
    role: 'assistant'
  });
  createCateAnswerList.value[createCateAnswerList.value.length - 1].text = await session.chat(createCateQuestion.value, (res) => {
    createCateAnswerList.value[createCateAnswerList.value.length - 1].text += res;
    if (createChatDom.value) {
      createChatDom.value.scrollTop += 3000
    }
  })
  createCateQuestion.value = '';
  createCateAnswerLoading.value = false
}
async function createCate() {
  createCateJSONLoading.value = true;
  let json = ''
  if (form.cateType === 1) {
    createCateAnswerList.value.push({
      text: '',
      role: 'assistant'
    });
    createCateAnswerList.value[createCateAnswerList.value.length - 1].text = await session.chat(`这些章节内容比例大概是什么样的？`, (res) => {
      createCateAnswerList.value[createCateAnswerList.value.length - 1].text += res;
      if (createChatDom.value) {
        createChatDom.value.scrollTop += 3000
      }
    })
    createCateAnswerList.value.push({
      text: '',
      role: 'assistant'
    });
    createCateAnswerList.value[createCateAnswerList.value.length - 1].text = await session.chat(`根据你说的比例，重新调整一下。占比较多的多划分一些子章节。占比较少的，少划分子章节。不要索引。`, (res) => {
      createCateAnswerList.value[createCateAnswerList.value.length - 1].text += res;
      if (createChatDom.value) {
        createChatDom.value.scrollTop += 3000
      }
    })
  }
  const createCatePrompt: string = (() => {
    if (form.cateType === 1) {
      return `根据你生成的目录章节，构建这个目录的json结构。
## 格式要求
格式需要是json格式，只返回json数据即可，json格式示例如下：
\`\`\`json${JSON.stringify(json1)}
\`\`\`
你生成的json，如上所示，不进行格式缩进，以去掉不必要的空格。每个children下至少有2个子节点。如果children下没有子节点，则不保留，不要出现\`\`\`"children": []\`\`\`这种空数组
`
    } else if (form.cateType === 2) {
      return `好的，根据你生成的目录，构建成json结构。
## 格式要求
格式需要是json格式，json格式示例如下：
\`\`\`json${JSON.stringify(demo1)}
\`\`\`
目录只有一层结构。数量和你刚才说的目录数量一致，title直接沿用目录名称。不要省略和合并内容，json可能很长，要完整展现出来。
`
    } else {
      return ''
    }
  })()
  if (!createCatePrompt) {
    return;
  }
  json = await session.chat(createCatePrompt, (res) => {
    json += res;
  }, {
    isGiveup: true,
    isJSON: true,
  })
  console.log(json)
  try {
    let children: CateItem[] = []
    try {
      children = JSON.parse(json);
    } catch (e) {
      children = eval(`(${json})`)
    }
    console.log('children', children);
    if (children.length === 1 && children[0].children) {
      children = children[0].children;
    }
    console.log(children);
    createCateJSON.value = children;
  } catch (e) {
    ElMessage.error('json结构不严格');
  }
  createCateJSONLoading.value = false;
}
async function createBook() {
  creteLoading.value = true;
  const bookInfoJSON = await session.chat(`给这个书起个15个字以内的吸引人的名字，然后总结一段30字以内的短描述，短描述适合印刷在封皮上
  ## json格式说明
\`\`\`json
{
  "name": "书名",
  "desc": "短描述",
}
\`\`\``, () => {
  }, {
    isJSON: true,
    isSessionEnd: true,
  })
  console.log(bookInfoJSON)
  try {
    const bookInfo: {
      name: string,
      desc: string,
    } = JSON.parse(bookInfoJSON);
    console.log(bookInfo)
    const insertInfo = {
      name: bookInfo.name, // 名字
      createUserSystem: form.system, // 创建者能力描述
      problem: form.bookProblem, // 帮助读者解决的问题
      desc: bookInfo.desc, // 副标题描述
      cateIsExamine: false, // 类目是否人工审核过完成初始化
      img: '', // 封皮
      cateJSON: JSON.stringify(createCateJSON.value), // 类目
      cateType: form.cateType,
      status: 0,
      type: form.type,
      strategy: insertStrategy.value, // 策略
    };
    console.log(insertInfo);
    const res = await post(`/createBook`, insertInfo);
    console.log('创建成功', res);
    if (res) {
      insertVisible.value = false;
      ElMessage.success('创建成功')
      await initBookList();
      console.log('创建成功2')
      const insertInfo = await get(`/bookInfo/${res}`)
      console.log('创建成功3', insertInfo)
      if (insertInfo) {
        console.log('创建成功4', insertInfo)
        editImgShow({
          id: insertInfo.id,
          name: insertInfo.name,
          desc: insertInfo.desc,
          problem: insertInfo.problem,
          createUserSystem: insertInfo.createUserSystem,
          img: insertInfo.img,
          status: insertInfo.status,
          type: insertInfo.type,
        })
      }
    }
  } catch (e: any) {
    console.error(e);
    ElMessage.error(e)
  }
  creteLoading.value = false;
}
async function editImgShow(book: IBook) {
  createImgInput.value = ''
  editImgIsShow.value = true
  createImgBook.value = book;
  sessionImg = new Session(book.createUserSystem)
  await chatCreateImg()
}

async function chatCreateImg() {
  if (!createImgBook.value) {
    return;
  }
  createImging.value = true
  const prompy: string = `我正在写一本《${createImgBook.value.name}》的书，书讲的是：${createImgBook.value.problem}。我想生成这本书的封面，需要百度千帆接口，调用大模型生成图片，
模型支持：${Object.values(allStyle).join('、')}，这${Object.values(allStyle).length}种风格，告诉我这本书最适合的一种风格和原因，如果没有特别贴切的，直接用通用风格。
给我两个备选的适合的主题背景色，除非特别合适，否则降低深蓝的使用。
再给我一到三个，能够匹配这本书，有具体形象的景观、物品或人物，不用告诉我原因。
说话简洁些
`
  createImgStep1Answer.value = '';
  createImgUrl.value = '';
  createImgStep2Answer.value = '';
  createImgStep1Colors.value = []
  createImgStep1StyleSelect.value = undefined;
  createImgStep1ColorsSelect.value = undefined;
  createImgStep2AnswerJSON.value = undefined
  createImgStep1Answer.value = await sessionImg.chat(prompy, (res) => {
    createImgStep1Answer.value += res;
  })
  console.log('createImgStep1Answer.value', createImgStep1Answer.value)
  const jsonText = await sessionImg.chat(`
根据刚才的信息，给我汇总一个json格式的数据。
## 格式要求
\`\`\`json
{
  "object": ["元素1","元素2","元素3"],
  "backgroundColor": ["十六进制颜色背景色1", "十六进制颜色背景色2"],
  "style": "风格"
}
\`\`\`
## 示例
\`\`\`json
{
  "object": ["香蕉","书本","路灯"],
  "backgroundColor": ["#6e8e82","#ff00ef"],
  "style": "折纸"
}
\`\`\`
`, (res) => {
    createImgStep1Answer.value += res
  }, {
    isJSON: true,
  })

  console.log('=====', jsonText)
  if (jsonText) {
    try {
      const json: {
        object: string[],
        backgroundColor: string[],
        style: (typeof allStyle)[keyof typeof allStyle],
      } = JSON.parse(jsonText);
      console.log('=====,3', json)
      const enumIndex = Object.values(allStyle).indexOf(json.style)
      const style: keyof typeof allStyle = Object.keys(allStyle)[enumIndex] as keyof typeof allStyle;
      if (style === undefined) {
        ElMessage.error('style不存在');
        return;
      } else {
        createImgStep1StyleSelect.value = style;
      }
      createImgStep1Colors.value = json.backgroundColor;
      createImgStep1ColorsSelect.value = createImgStep1Colors.value[0]
      createImgStep1ObjectSelect.value = json.object;
      createImging.value = false;
      chatCreateImgStep2()
    } catch (e) {
      createImging.value = false;
      ElMessage.error('json结构不对')
    }
  }
}
async function chatCreateImgStep2() {
  if (createImgStep1ColorsSelect.value === undefined || createImgStep1StyleSelect.value === undefined || createImgStep1ObjectSelect.value === undefined) {
    return;
  }
  createImgStep2AnswerJSON.value = undefined
  createImging.value = true
  const mainColor: string = createImgStep1ColorsSelect.value;
  const objects: string[] = createImgStep1ObjectSelect.value;
  createImgStep2Answer.value = '';
  const prompt = await sessionImg.chat(`帮助我写一个中文的文生图模型的Prompt。
## 要求如下
背景主色调接近十六进制颜色代码“${mainColor}”。
让图片上半部分有大面积纯色留白，比如添加蓝色的天空，白色的黑板，纯色的墙面，大片雪地。
包含元素${objects.join('、')}中的一个或多个，元素尽可能在图片下半部分。
简约一些，图片不要太乱。
给我一个符合这个表述的文生图Prompt。
## 格式如下
\`\`\`json
{
  "prompt": "文生图Prompt正文"
}
\`\`\`
`, (res) => {
    createImgStep2Answer.value += res
  }, {
    isJSON: true,
    isSessionEnd: true,
  })
  let json2
  try {
    json2 = JSON.parse(prompt)
  } catch (e) {
    json2 = eval(`(${prompt})`)
  }
  createImgStep2AnswerJSON.value = json2;
  createImging.value = false
  chatCreateImgStep3()
}
async function chatCreateImgStep3() {
  if (createImgStep1StyleSelect.value === undefined || createImgStep2AnswerJSON.value === undefined) {
    return;
  }
  createImging.value = true
  const selectStyle: keyof typeof allStyle = createImgStep1StyleSelect.value;
  post('/createBookImg', {
    prompt: createImgStep2AnswerJSON.value.prompt,
    style: selectStyle
  }).then(res => {
    console.log('createBookImg', res)
    createImgUrl.value = "data:image/png;base64," + res.data[0].b64_image;
    // charGPTStrLoading.value[sentUserId] = false;
  }).finally(() => {
    createImging.value = false;
  })
}
async function saveCreateImg() {
  if (!createImgUrl.value || !createImgBook.value) {
    return;
  }
  const base64ToBlob = (dataurl: string) => {
    const arr = dataurl.split(',')
    // @ts-ignore
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], { type: mime })
  }

  const formData = new FormData()
  saveImg.value = true
  formData.append('file', base64ToBlob(createImgUrl.value))
  const data = await post('/oss', formData)
  const { url } = data;
  if (url) {
    console.log('ddddd-2', data)
    editImgIsShow.value = false;
    await put(`/setBookImg/${createImgBook.value.id}`, {
      img: url,
    })
    saveImg.value = false
    initBookList()
  }
}
function deleteBook(book: IBook) {
  ElMessageBox.confirm('是否删除:' + book.name, {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(async () => {
    await Delete(`/deleteBook/${book.id}`)
    initBookList()
  }).catch(() => {
    // 用户取消删除
  })
}
function createClose() {
  createStep.value = 0
  createCateQuestion.value = ''
  createCateAnswerList.value = [];
  createCateJSON.value = []
}

return (_ctx: any,_cache: any) => {
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(ElButton), { onClick: initInsert }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
          _createTextVNode("通过想法新增", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookList.value, (book) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "book",
          onClick: ($event: any) => (turnDetail(book.id)),
          key: book.id
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, _toDisplayString(book.name), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (book.img)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "img",
                  src: book.img + '?x-oss-process=image/resize,w_300,quality,q_60'
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(ElButton), {
              size: "small",
              type: book.img ? 'default' : 'primary',
              onClick: _withModifiers(($event: any) => (editImgShow(book)), ["stop"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(book.img ? '重新生成封皮' : '生成封皮'), 1)
              ]),
              _: 2
            }, 1032, ["type", "onClick"]),
            _cache[11] || (_cache[11] = _createElementVNode("div", { style: {"flex-grow":"1"} }, null, -1)),
            _createVNode(_unref(ElButton), {
              size: "small",
              type: "warning",
              onClick: _withModifiers(($event: any) => (deleteBook(book)), ["stop"])
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode(" 删除", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ])
        ], 8, _hoisted_3))
      }), 128))
    ]),
    _createVNode(_unref(ElDialog), {
      modelValue: insertVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((insertVisible).value = $event)),
      onClose: createClose,
      title: "新增专题",
      width: "80%"
    }, {
      default: _withCtx(() => [
        (createStep.value === 0)
          ? (_openBlock(), _createBlock(_unref(ElForm), {
              key: 0,
              model: form
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElFormItem), {
                  required: "",
                  label: "写这本书的人的特点"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElInput), {
                      modelValue: form.system,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.system) = $event)),
                      placeholder: "例如：精通儿童辅食制作"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(ElFormItem), {
                  required: "",
                  label: "这本书要解决啥问题，或达到什么目的"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElInput), {
                      modelValue: form.bookProblem,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.bookProblem) = $event)),
                      placeholder: "例如：新手妈妈制作营养丰富的儿童辅食"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(ElFormItem), {
                  required: "",
                  label: "书本结构"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElRadioGroup), {
                      modelValue: form.cateType,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.cateType) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElRadio), { value: 1 }, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createTextVNode("树状结构：常用于知识/工具书", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_unref(ElRadio), { value: 2 }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createTextVNode("线性结构：故事/编年体", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(ElFormItem), {
                  required: "",
                  label: "分类"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElSelect), {
                      placeholder: "请选择专栏所属的分类",
                      disabled: form.system == '' || form.bookProblem === '',
                      modelValue: form.type,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.type) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, (item) => {
                          return (_openBlock(), _createBlock(_unref(ElOption), {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["disabled", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(ElFormItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      type: "primary",
                      onClick: begin
                    }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode("开始", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true),
        (createStep.value === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (createCateJSON.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", {
                      ref_key: "createChatDom",
                      ref: createChatDom,
                      class: "chatList"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(createCateAnswerList.value, (createCateAnswer) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["chatItem", { user: createCateAnswer.role === 'user' }]),
                          innerHTML: createCateAnswer.text.replace(/\n/g, '<br/>')
                        }, null, 10, _hoisted_10))
                      }), 256)),
                      (createCateAnswerLoading.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                            _createVNode(_unref(ElIcon), null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Loading)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ], 512),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_unref(ElInput), {
                        modelValue: createCateQuestion.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((createCateQuestion).value = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_unref(ElButton), {
                        onClick: chatBeter,
                        loading: createCateAnswerLoading.value,
                        disabled: createCateJSONLoading.value,
                        style: {"margin-left":"8px"}
                      }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode("沟通", -1)
                        ]))]),
                        _: 1
                      }, 8, ["loading", "disabled"]),
                      _createVNode(_unref(ElButton), {
                        onClick: createCate,
                        loading: createCateJSONLoading.value,
                        disabled: createCateAnswerLoading.value,
                        style: {"margin-left":"8px"}
                      }, {
                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                          _createTextVNode("完成沟通，下一步", -1)
                        ]))]),
                        _: 1
                      }, 8, ["loading", "disabled"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (createCateJSON.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(createCateJSON.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, _toDisplayString(item.title), 1),
                            _createElementVNode("div", _hoisted_18, _toDisplayString(item.desc), 1)
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (item2) => {
                              return (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("div", _hoisted_22, _toDisplayString(item2.title), 1),
                                  _createElementVNode("div", _hoisted_23, _toDisplayString(item2.desc), 1)
                                ]),
                                _createElementVNode("div", _hoisted_24, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.children, (item3) => {
                                    return (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                      _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("div", _hoisted_27, _toDisplayString(item3.title), 1),
                                        _createElementVNode("div", _hoisted_28, _toDisplayString(item3.desc), 1)
                                      ])
                                    ]))
                                  }), 256))
                                ])
                              ]))
                            }), 256))
                          ])
                        ]))
                      }), 256))
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_unref(ElButton), {
                        onClick: createBook,
                        size: "large",
                        type: "primary",
                        loading: createCateJSONLoading.value || creteLoading.value,
                        disabled: createCateAnswerLoading.value || createCateJSON.value.length === 0
                      }, {
                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                          _createTextVNode("创建专题", -1)
                        ]))]),
                        _: 1
                      }, 8, ["loading", "disabled"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(ElDialog), {
      modelValue: editImgIsShow.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editImgIsShow).value = $event)),
      title: "封皮生成",
      width: "80%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_30, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "title" }, "选择主题和风格", -1)),
          _createElementVNode("div", {
            innerHTML: createImgStep1Answer.value.replace(/\n/g, '<br/>')
          }, null, 8, _hoisted_31),
          (createImgStep1StyleSelect.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(allStyle), (styleKey) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["styleItem", { active: createImgStep1StyleSelect.value === styleKey }]),
                    onClick: ($event: any) => (!createImging.value ? createImgStep1StyleSelect.value = styleKey : '')
                  }, [
                    _createElementVNode("div", null, _toDisplayString(allStyle[styleKey] ? allStyle[styleKey] : ''), 1)
                  ], 10, _hoisted_33))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_34, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(createImgStep1Colors.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                onClick: ($event: any) => (!createImging.value ? createImgStep1ColorsSelect.value = item : ''),
                class: _normalizeClass(["seggestColorItem", { active: createImgStep1ColorsSelect.value === item }]),
                style: _normalizeStyle({ backgroundColor: item })
              }, _toDisplayString(item), 15, _hoisted_35))
            }), 256))
          ]),
          (!createImging.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createVNode(_unref(ElButton), { onClick: chatCreateImgStep2 }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                    _createTextVNode("重新生成下一步", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_37, [
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "title" }, "生成提示词", -1)),
          (createImgStep2AnswerJSON.value)
            ? (_openBlock(), _createBlock(_unref(ElInput), {
                key: 0,
                type: "textarea",
                autosize: "",
                modelValue: createImgStep2AnswerJSON.value.prompt,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((createImgStep2AnswerJSON.value.prompt) = $event))
              }, null, 8, ["modelValue"]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                innerHTML: createImgStep2Answer.value.replace(/\n/g, '<br/>')
              }, null, 8, _hoisted_38)),
          (!createImging.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createVNode(_unref(ElButton), { onClick: chatCreateImgStep3 }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                    _createTextVNode("重新生成图片", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_40, [
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "title" }, "绘图", -1)),
          _createElementVNode("div", null, [
            (createImging.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, "生成图片中"))
              : (saveImg.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, "保存中"))
                : _createCommentVNode("", true),
            _createElementVNode("img", {
              src: createImgUrl.value,
              style: {"width":"400px"}
            }, null, 8, _hoisted_43)
          ]),
          _createElementVNode("div", null, [
            (createImgUrl.value)
              ? (_openBlock(), _createBlock(_unref(ElButton), {
                  key: 0,
                  style: {"width":"400px"},
                  size: "large",
                  type: "primary",
                  onClick: saveCreateImg,
                  disabled: createImging.value || !createImgUrl.value,
                  loading: saveImg.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(saveImg.value ? '保存中' : '保存'), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(ElDialog), {
      modelValue: twoChatShow.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((twoChatShow).value = $event)),
      title: "产生选题",
      width: "80%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_44, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(twoChatContnt.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["chat", { chat1: item.user === 'chat1', chat2: item.user === 'chat2' }])
            }, [
              _createElementVNode("div", _hoisted_45, _toDisplayString(item.user === 'chat1' ? '发版员' : '审核员'), 1),
              _createElementVNode("div", _hoisted_46, _toDisplayString(item.content), 1)
            ], 2))
          }), 256))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})